import styled from 'styled-components';

const Wrapper = styled.div<{ diameterSm: string }>`
  height: 100%;
  min-width: 80px;
  .person-skeleton-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    .group-1 {
      height: 20px;
      border-radius: 25px;
      width: 70%;
      margin-bottom: 5px;
      margin-top: 5px;
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
`;

type Props = {
  diameterSm?: string,
} & typeof defaultProps;

const defaultProps = {
  diameterSm: '',
};

const AffinitySearchNameSkeleton = function AffinitySearchNameSkeleton(props: Props) {
  const { diameterSm } = props;
  return (
    <Wrapper diameterSm={diameterSm}>
      <div className="person-skeleton-wrapper">
        <span className="skeleton-box group-1" />
      </div>
    </Wrapper>
  );
};

AffinitySearchNameSkeleton.defaultProps = defaultProps;
export default AffinitySearchNameSkeleton;
